
import { useState, useEffect } from 'react';

export interface MobileBrowserState {
  isMobile: boolean;
  browserType: string;
  isIOS: boolean;
  isAndroid: boolean;
  isInAppBrowser: boolean;
  isInstagramWebView: boolean;
  isFacebookWebView: boolean;
}

export function useMobileBrowser(): MobileBrowserState {
  const [state, setState] = useState<MobileBrowserState>({
    isMobile: false,
    browserType: 'unknown',
    isIOS: false,
    isAndroid: false,
    isInAppBrowser: false,
    isInstagramWebView: false,
    isFacebookWebView: false
  });

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || '';
    
    // Enhanced mobile detection
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    
    // OS detection
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    
    // Enhanced in-app browser detection
    const isInAppBrowser = /FBAN|FBAV|Instagram|Twitter|Pinterest|Line|NAVER|KAKAOTALK|Snapchat|WhatsApp/i.test(userAgent);
    const isInstagramWebView = /Instagram/.test(userAgent);
    const isFacebookWebView = /FBAN|FBAV/.test(userAgent);
    
    // Enhanced browser detection
    let browserType = 'unknown';
    if (userAgent.indexOf('CriOS') > -1 || userAgent.indexOf('Chrome') > -1) browserType = 'chrome';
    else if (userAgent.indexOf('FxiOS') > -1 || userAgent.indexOf('Firefox') > -1) browserType = 'firefox';
    else if (userAgent.indexOf('EdgiOS') > -1 || userAgent.indexOf('Edge') > -1 || userAgent.indexOf('Edg') > -1) browserType = 'edge';
    else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1) browserType = 'ie';
    else if (userAgent.indexOf('OPiOS') > -1 || userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) browserType = 'opera';
    else if (userAgent.indexOf('Safari') > -1) browserType = 'safari';
    
    // Social media app specific detection
    if (isInAppBrowser) {
      if (isInstagramWebView) browserType = 'instagram-webview';
      else if (isFacebookWebView) browserType = 'facebook-webview'; 
      else browserType = 'in-app-browser';
    }
    
    setState({ 
      isMobile, 
      browserType, 
      isIOS, 
      isAndroid, 
      isInAppBrowser,
      isInstagramWebView,
      isFacebookWebView
    });
    
    console.log(`Browser detected: ${browserType} (Mobile: ${isMobile ? 'yes' : 'no'}, iOS: ${isIOS ? 'yes' : 'no'}, Android: ${isAndroid ? 'yes' : 'no'}, In-app: ${isInAppBrowser ? 'yes' : 'no'}, Instagram: ${isInstagramWebView ? 'yes' : 'no'})`);
    
  }, []);

  return state;
}
